"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SqlMgrv2Trans;
    }
});
const _KnexMigratorv2Tans = /*#__PURE__*/ _interop_require_default(require("../../sql-migrator/lib/KnexMigratorv2Tans"));
const _SqlMgrv2 = /*#__PURE__*/ _interop_require_default(require("./SqlMgrv2"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SqlMgrv2Trans = class SqlMgrv2Trans extends _SqlMgrv2.default {
    async migrator() {
        return new _KnexMigratorv2Tans.default(this.context, {
            id: this.baseId
        }, await this.getSqlClient(this.source), this.ncMeta);
    }
    async startTransaction(source) {
        const knex = await _NcConnectionMgrv2.default.get(source);
        this.trx = await knex.transaction();
    }
    async commit() {
        if (this.trx) {
            await this.trx.commit();
            this.trx = null;
        }
    }
    async rollback(error) {
        if (this.trx) {
            await this.trx.rollback(error);
            this.trx = null;
        }
    }
    async getSqlClient(source) {
        return _NcConnectionMgrv2.default.getSqlClient(source, this.trx);
    }
    async sqlOp(source, op, opArgs) {
        return super.sqlOp(source, op, opArgs);
    }
    async sqlOpPlus(source, op, opArgs) {
        return super.sqlOpPlus(source, op, opArgs);
    }
    /**
   * Creates an instance of SqlMgr.
   * @param {*} args
   * @param {String} args.toolDbPath - path to sqlite file that sql mgr will use
   * @memberof SqlMgr
   */ // todo: tobe changed
    constructor(context, args, ncMeta, source){
        super(context, args);
        this.baseId = args.id;
        this.ncMeta = ncMeta;
        this.source = source;
    }
};
